import { Button, Checkbox, Divider, FormControlLabel, Grid, Switch, Typography } from '@mui/material'

import { useAuthentication } from '../../providers/auth-provider'
import { defaultSearchFilters } from '../../routes/search-results/helpers'
import useSharedStyles from '../../utils/shared.styles'

import getFilterOptions from './filterOptions'

interface IProps {
  tab: SearchTabsType
  searchFilters: IFilterOptions | undefined
  selectFilters: (newFilters: IFilterOptions) => void
  hasActiveFilters: boolean
}

const SearchFilters = (props: IProps) => {
  const { tab, searchFilters, selectFilters, hasActiveFilters } = props

  const { hasInternalUserAccess } = useAuthentication()
  const sharedClasses = useSharedStyles

  const prevSearchFilters = searchFilters ?? defaultSearchFilters

  const onChangeCheckbox = ({ property, value }: { property: 'folderTypes' | 'roleNames' | 'properties' | 'statuses'; value: FolderType | string }) => {
    const newFilters = {
      ...prevSearchFilters,
      [property]: prevSearchFilters[property].includes(value as FolderType)
        ? prevSearchFilters[property].filter((type: string) => type !== value)
        : [...prevSearchFilters[property], value],
    }

    selectFilters(newFilters)
  }

  const onChangeSwitch = ({ property, value }: { property: 'hideDeactivated' | 'excludeOptOut' | 'hideNonProduction'; value: boolean }) => {
    const newFilters = {
      ...prevSearchFilters,
      [property]: value,
    }

    selectFilters(newFilters)
  }

  const clearFilters = () => {
    selectFilters(defaultSearchFilters)
  }

  const filterOptions = getFilterOptions(hasInternalUserAccess)
  const checkboxGroup = filterOptions[tab].groups[0]
  const switchGroup = filterOptions[tab].groups[1]

  return (
    <>
      <Grid container={true} direction="row" sx={[sharedClasses.centerContentVertical, { justifyContent: 'space-between' }]}>
        <Typography variant="body1">Filters</Typography>
        <Button onClick={clearFilters} disabled={!hasActiveFilters}>
          Reset
        </Button>
      </Grid>
      <Divider sx={{ marginBottom: 2 }} />
      <Typography variant="subtitle2">{checkboxGroup.title}</Typography>
      {checkboxGroup.controls.map((control, idx) => (
        <FormControlLabel
          key={idx}
          control={<Checkbox checked={(prevSearchFilters[control.property] as string[]).includes(control.label)} />}
          label={control.label}
          slotProps={{
            typography: {
              onClick: (e) => e.preventDefault(),
            },
          }}
          sx={{ display: 'block' }}
          onClick={() => onChangeCheckbox({ property: control.property as 'folderTypes' | 'roleNames' | 'properties' | 'statuses', value: control.label })}
        />
      ))}
      {switchGroup && <Typography variant="subtitle2">{switchGroup.title}</Typography>}
      {switchGroup?.controls.map((control, idx) => (
        <FormControlLabel
          key={idx}
          control={<Switch checked={prevSearchFilters[control.property] as boolean} />}
          label={control.label}
          slotProps={{
            typography: {
              onClick: (e) => e.preventDefault(),
            },
          }}
          sx={{ display: 'block' }}
          onClick={() =>
            onChangeSwitch({
              property: control.property as 'hideDeactivated' | 'excludeOptOut' | 'hideNonProduction',
              value: !prevSearchFilters[control.property],
            })
          }
        />
      ))}
    </>
  )
}

export default SearchFilters
